import { useMutation } from '@tanstack/react-query';
import { processCustomerEkyc, resentOtp, ekycOtpVerify } from 'utils/API/Merchant APIs/UpdatedAPIs/DMTUpdatedAPICalls';

export const useProcessEkyc = () => {
    return useMutation({
        mutationFn: processCustomerEkyc
    });
};

export const useResendOtp = () => {
    return useMutation({
        mutationFn: resentOtp
    });
};

export const useVerifyOtp = () => {
    return useMutation({
        mutationFn: ekycOtpVerify
    });
};
